import { createI18n } from 'vue-i18n'
import uk from '@/i18n/locales/uk'
import ru from '@/i18n/locales/ru'

const savedLocale = localStorage.getItem('unilib_locale')
const locale = savedLocale === 'ru' ? 'ru' : 'uk'

const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'uk',
  messages: {
    uk,
    ru,
  },
})

export default i18n